export default __webpack_public_path__ + "static/media/rmall-project-3.a2541fef.png";